<svg
  width="19"
  height="19"
  viewBox="0 0 19 19"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.0312 2.375H6.53125C6.37378 2.375 6.22276 2.43756 6.11141 2.54891C6.00006 2.66026 5.9375 2.81128 5.9375 2.96875V5.9375H2.96875C2.81128 5.9375 2.66026 6.00006 2.54891 6.11141C2.43756 6.22276 2.375 6.37378 2.375 6.53125V16.0312C2.375 16.1887 2.43756 16.3397 2.54891 16.4511C2.66026 16.5624 2.81128 16.625 2.96875 16.625H12.4688C12.6262 16.625 12.7772 16.5624 12.8886 16.4511C12.9999 16.3397 13.0625 16.1887 13.0625 16.0312V13.0625H16.0312C16.1887 13.0625 16.3397 12.9999 16.4511 12.8886C16.5624 12.7772 16.625 12.6262 16.625 12.4688V2.96875C16.625 2.81128 16.5624 2.66026 16.4511 2.54891C16.3397 2.43756 16.1887 2.375 16.0312 2.375ZM11.875 15.4375H3.5625V7.125H11.875V15.4375ZM15.4375 11.875H13.0625V6.53125C13.0625 6.37378 12.9999 6.22276 12.8886 6.11141C12.7772 6.00006 12.6262 5.9375 12.4688 5.9375H7.125V3.5625H15.4375V11.875Z"
    fill="#F1B432"
  />
</svg>
